import { isEmpty } from "lodash";

const ErrorMessage = ({ message }) => {
  if (isEmpty(message)) return null;

  return <p className="invalid">{message}</p>;
};

export default ErrorMessage;
